function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.748841,23.1630546 C19.6581587,24.9328431 16.9537033,26 14,26 C7.372583,26 2,20.627417 2,14 C2,7.372583 7.372583,2 14,2 C20.627417,2 26,7.372583 26,14 C26,16.9537033 24.9328431,19.6581587 23.1630546,21.748841 L30.7071068,29.2928932 L29.2928932,30.7071068 L21.748841,23.1630546 Z M14,24 C19.5228475,24 24,19.5228475 24,14 C24,8.4771525 19.5228475,4 14,4 C8.4771525,4 4,8.4771525 4,14 C4,19.5228475 8.4771525,24 14,24 Z M15,13 L22,13 L22,15 L15,15 L15,22 L13,22 L13,15 L6,15 L6,13 L13,13 L13,6 L15,6 L15,13 Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/zoom-in.f57b3258.svg";
export { SvgComponent as ReactComponent };